import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from '@latitude/link';
import {
  ALIGN,
  BREAKPOINT,
  COLOR,
  FONT_SIZE,
  CALCULATOR_TRACKING_V2
} from '../../utils/constants';
import Text from '../Text/Text';
import FeeBreakDownModal from './FeeBreakdownModal';
import Typography from '@latitude/typography';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';

/**
 * PL Disclaimer content
 */
const StyledDisclaimerText = styled.div`
  text-align: start;
  .typography-base__body {
    font-weight: 500;
  }
`;

const StyledFeesDesktopLink = styled(Link)`
  display: inline;
  color: ${({ validationError }) =>
    validationError ? REBRAND_COLOR.BLACK_80 : REBRAND_COLOR.MID_BLUE};
  border-bottom: ${({ validationError }) =>
    validationError
      ? `1px solid ${REBRAND_COLOR.BLACK_80}`
      : `1px solid ${REBRAND_COLOR.MID_BLUE}`};
  cursor: ${({ validationError }) =>
    validationError ? 'not-allowed' : 'pointer'};
  :hover {
    border-bottom: ${({ validationError }) =>
      validationError
        ? `1px solid ${REBRAND_COLOR.BLACK_80}`
        : `1px solid ${REBRAND_COLOR.MID_BLUE}`};
    text-shadow: ${({ validationError }) =>
      validationError ? 'none' : `0 0 1px ${REBRAND_COLOR.MID_BLUE}`};
  }
`;

function PLDisclaimerContent({
  repaymentFreq,
  repaymentAmount,
  isVariable,
  isLefWaiver,
  validationError,
  isSecured
}) {
  const [showFeesModal, setShowFeesModal] = useState(false);
  const linkLabel = 'Fees & Charges';
  const trackingData = {
    category: CALCULATOR_TRACKING_V2.CATEGORY,
    action: CALCULATOR_TRACKING_V2.ACTION,
    location: CALCULATOR_TRACKING_V2.LOCATION,
    label: linkLabel
  };
  console.log('issecured', isSecured);

  return (
    <>
      <StyledDisclaimerText fontSize={FONT_SIZE.SMALL}>
        <Typography.Body small color={REBRAND_COLOR.BLACK_80}>
          This calculator is provided for illustrative purposes only and does
          not constitute a quote or pre-qualification. The interest rate you may
          be offered can differ from the interest rate displayed above and will
          be based on your personal circumstances. The total amount paid
          includes establishment and monthly fees. See all{' '}
          <StyledFeesDesktopLink
            onClick={e => {
              e.preventDefault();

              if (!validationError) {
                setShowFeesModal(true);
              }
            }}
            trackEventData={trackingData}
            validationError={validationError}
          >
            {linkLabel}
          </StyledFeesDesktopLink>{' '}
          for this product.
        </Typography.Body>
      </StyledDisclaimerText>

      <FeeBreakDownModal
        showFeesModal={showFeesModal}
        isLefWaiver={isLefWaiver}
        setShowFeesModal={setShowFeesModal}
        repaymentAmount={repaymentAmount}
        repaymentPeriod={repaymentFreq}
        isVariable={isVariable}
        isSecured={isSecured}
      />
    </>
  );
}

export default PLDisclaimerContent;
